import { useMutation } from "@apollo/react-hooks";
import { editProduct as editProductMutation } from "../../mutations";
import { getProduct } from "../../queries";
import { GetOwnedProducts } from "../../../../pages/Products/queries";
import { buildGetOwnedProductsVariables } from "../../helpers";
import buildEditProductVariable from "./buildEditProductVariable";
import buildEditVariantsVariable from "./buildEditVariantsVariable";
import buildEditOptionsVariable from "./buildEditOptionsVariable";
import buildEditImagesVariable from "./buildEditImagesVariable";

const useEditProduct = ({
  productId,
  product,
  informationTabProps: {
    hasVariants,
    acceptsDonations,
    ...informationTabProps
  },
  variantTabProps,
  imageTabProps,
  searchText
}) => {
  const variables = product && {
    product: buildEditProductVariable(
      informationTabProps,
      product,
      hasVariants,
      acceptsDonations
    ),
    variants: buildEditVariantsVariable(variantTabProps, product, hasVariants),
    options: buildEditOptionsVariable(variantTabProps, product, hasVariants),
    images: buildEditImagesVariable(informationTabProps, imageTabProps, product)
  };

  return useMutation(editProductMutation, {
    variables,
    awaitRefetchQueries: true,
    refetchQueries: [
      { query: getProduct, variables: { id: productId } },
      {
        query: GetOwnedProducts,
        ...buildGetOwnedProductsVariables(searchText)
      }
    ]
  });
};

export default useEditProduct;
